import { Route, Routes, BrowserRouter } from "react-router-dom";
import CommonContainer from "./CommanContainer";
import Home from "./Pages/Home";
import Projects from "./Pages/Projects";
import Blogs from "./Pages/Blogs";
import Skills from "./Pages/Skills/Skills";
import Services from "./Pages/Services";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <CommonContainer>
              <Home />
            </CommonContainer>
          }
        />
        {/* <Route path="work-history"
            element={
              <CommonContainer>
                <Experience />
              </CommonContainer>
            } /> */}
        <Route
          path="projects"
          element={
            <CommonContainer>
              <Projects />
            </CommonContainer>
          }
        />
        {/* <Route path="resume"
            element={
              <CommonContainer>
                <Resume />
              </CommonContainer>
            } /> */}
        <Route
          path="blogs"
          element={
            <CommonContainer>
              <Blogs />
            </CommonContainer>
          }
        />

        <Route
          path="skills"
          element={
            <CommonContainer>
              <Skills />
            </CommonContainer>
          }
        />

        <Route
          path="services"
          element={
            <CommonContainer>
              <Services />
            </CommonContainer>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
